/** Deep-removes undefined values so Firestore writes never throw "Unsupported field value: undefined". */
export function stripUndefined<T>(value: T): T {
  if (Array.isArray(value)) return value.map((item) => stripUndefined(item)) as unknown as T
  if (value && typeof value === 'object' && !(value instanceof Date) && !(value instanceof File) && !(value instanceof Blob)) {
    const out: Record<string, unknown> = {}
    for (const [key, item] of Object.entries(value as Record<string, unknown>)) {
      if (item !== undefined) out[key] = stripUndefined(item)
    }
    return out as T
  }
  return value
}

/** True when no undefined value exists anywhere in the object (used by tests). */
export function hasNoUndefined(value: unknown): boolean {
  if (value === undefined) return false
  if (Array.isArray(value)) return value.every((item) => hasNoUndefined(item))
  if (value && typeof value === 'object') return Object.values(value).every((item) => hasNoUndefined(item))
  return true
}
